(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["resultats"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.resultats-typeform .product-recommandations .typeform-products').forEach(function(reco) {
    if (reco.children.length === 0) {
      reco.closest(".product-recommandations").remove();
    }
  });
  
  document.querySelectorAll('.resultats-typeform .product-recommandations .h2').forEach(function(h2, index) {
    h2.textContent = (index + 1) + ". " + h2.textContent;
  });

  } catch(e) { console.error(e); }
})();
})();
